import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { getProductListAsync } from "../../../../../app/slices/productTypesSlice/productTypesSlice";
import ProductTypesSkeleton from "./skeletons/ProductTypesSkeleton";
import { Link, useNavigate } from "react-router-dom";

export const ProductTypes = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getProductListAsync());
  }, []);
  const productList = useAppSelector(
    (state) => state.productTypesState.productTypes
  );
  const location = useAppSelector((state) => state.locationState);
  return (
    <>
      {productList?.loader ? (
        <ProductTypesSkeleton />
      ) : (
        <section
          className="flat-spacing-20 mt-3"
          style={{
            fontFamily: "Albert Sans, sans-serif",
            fontSize: "14px",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tf-categories-wrap">
                {location?.locationGot?.location_message && (
                  <div className="tf-sticky-note">
                    <div className="tf-sticky-note-content">
                      <div className="tf-sticky-note-icon">📍</div>
                      <div className="tf-sticky-note-text">
                        <h4 className="tf-sticky-note-title">
                          Service not available in your area
                        </h4>
                        <p className="tf-sticky-note-message">
                          {location?.locationGot?.location_message}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                  <div className="tf-categories-container">
                    {[...(productList?.data || [])]
                      .reverse()
                      ?.slice(1, 9)
                      ?.map((item: any, i: any) => {
                        return (
                          <div
                            key={item?.category_code}
                            className="collection-item-circle hover-img"
                          >
                            <span
                              className="collection-image img-style"
                              style={{ height: "60px", width: "60px" }}
                            >
                              <Link
                                to={{
                                  pathname: `/product/${item?.category_code}`,
                                }}
                                onClick={() =>
                                  localStorage.setItem(
                                    "Category_code",
                                    item?.category_code
                                  )
                                }
                              >
                                <img
                                  className="lazyload"
                                  data-src={`${process.env.REACT_APP_API_URL}${item?.icon}`}
                                  src={`${process.env.REACT_APP_API_URL}${item?.icon}`}
                                  alt=""
                                />
                              </Link>
                            </span>
                            <div className="collection-content text-center">
                              <span className="link title fw-6">
                                {item?.category_name}
                              </span>
                            </div>
                          </div>
                        );
                      })}

                    {/* <div className="collection-item-circle hover-img">
                      <a
                        href="inner.html"
                        className="collection-image img-style"
                      >
                        <img
                          className="lazyload"
                          data-src="images/sweets.svg"
                          src="images/sweets.svg"
                          alt=""
                        />
                      </a>
                      <div className="collection-content text-center">
                        <a href="inner.html" className="link title fw-6">
                          Sweets
                        </a>
                      </div>
                    </div>
                    <div className="collection-item-circle hover-img">
                      <a
                        href="inner.html"
                        className="collection-image img-style"
                      >
                        <img
                          className="lazyload"
                          data-src="images/snacks1.svg"
                          src="images/snacks1.svg"
                          alt=""
                        />
                      </a>
                      <div className="collection-content text-center">
                        <a href="inner.html" className="link title fw-6">
                          Snacks
                        </a>
                      </div>
                    </div>
                    <div className="collection-item-circle hover-img">
                      <a
                        href="inner.html"
                        className="collection-image img-style"
                      >
                        <img
                          className="lazyload"
                          data-src="images/dryfruits.svg"
                          src="images/dryfruits.svg"
                          alt=""
                        />
                      </a>
                      <div className="collection-content text-center">
                        <a href="inner.html" className="link title fw-6">
                          Dry Fruits
                        </a>
                      </div>
                    </div>
                    <div className="collection-item-circle hover-img">
                      <a
                        href="inner.html"
                        className="collection-image img-style"
                      >
                        <img
                          className="lazyload"
                          data-src="images/kerala.svg"
                          src="images/kerala.svg"
                          alt=""
                        />
                      </a>
                      <div className="collection-content text-center">
                        <a href="inner.html" className="link title fw-6">
                          Kerala Specialities
                        </a>
                      </div>
                    </div>
                    <div className="collection-item-circle hover-img">
                      <a
                        href="inner.html"
                        className="collection-image img-style"
                      >
                        <img
                          className="lazyload"
                          data-src="images/bread.svg"
                          src="images/bread.svg"
                          alt=""
                        />
                      </a>
                      <div className="collection-content text-center">
                        <a href="inner.html" className="link title fw-6">
                          Breads
                        </a>
                      </div>
                    </div>
                    <div className="collection-item-circle hover-img">
                      <div className="has-saleoff-wrap position-relative">
                        <a
                          href="inner.html"
                          className="collection-image img-style"
                        >
                          <img
                            className="lazyload"
                            data-src="images/muffins.svg"
                            src="images/muffins.svg"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="collection-content text-center">
                        <a href="inner.html" className="link title fw-6">
                          Muffins & Pastries
                        </a>
                      </div>
                    </div>
                  </div>*/}
                    <div className="tf-shopall-wrap">
                      <div className="collection-item-circle tf-shopall">
                        <span
                          style={{
                            cursor: "pointer",
                            marginBottom: "12px",
                            marginTop: "8px",
                          }}
                          className="collection-image img-style tf-shopall-icon"
                          onClick={() => navigate("/shopAll")}
                        >
                          <i className="icon icon-arrow1-top-left"></i>
                        </span>
                        <div className="collection-content text-center">
                          <span className="link title fw-6">Shop all</span>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
